var _rect, _g, _rect2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDexterCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_3428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0634766,
    width: 27,
    height: 27,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_3428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.93652,
    width: 34,
    height: 25,
    fill: "url(#paint0_linear_31_3428)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31_3428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 7,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3135,
    y: 7.59375,
    width: 8.71875,
    height: 8.71875,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31_3428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.93652,
    width: 34,
    height: 25,
    fill: "url(#paint1_linear_31_3428)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_3428",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_31_3428",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_3428",
    x1: 14.0635,
    y1: 0,
    x2: 14.0635,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C6C6",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_3428",
    x1: 14.0635,
    y1: 0,
    x2: 14.0635,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C6C6",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_3428",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADjUlEQVR4nO2bT2tVRxjGx1I0bRNtd5WCCFW7M3SnX6AfQVHc2pXQr6CuAslKwVgToZtuJK4ttJsiEhUXQhe1Cze1GK435J55nklQo46MOYEgtr25uee8c+55fvDC5f6Ze97nmZkz/45zQgghhBBCCCGEEEJkxvLy8l6Sp0nOAbhP8hmAlynK1+m9ayRPdbvdCevrHRm899+QvA5gjWTsJwCskpz33h+2vv7GEmP8FMAMgPV+hf+AEamFTMcYx6zzaRTe+8MA/hhU+A/E3RDCfuu8GkEI4dvUpw9R/M3W8E8IYdI6v+xrPisQf4sJT9QS/oUY4xiAh1WJv8WEB+n+Um/VagAAZqoWf0tctM43u6EmdjDaGSCCuqItkLxeo/ibMWtX5TKb4WJj4lSrAek/NWN272r/aYPavxknXdshOWdowI+u7WBjEc3KgEXXdkh2rQwA0HFtB8ALQwOeu7YDGWAL1QXZAt2EbeHGNqLVKOiqazskTxkacMK1nW63O2G1FNHpdMat82/zYtycdd7Z4L0/Uh4vqav2vyiK4mvrvLMCwHSNtX/KOt8styRJLta0JfmJdb5ZEkL4EsDfFYr/dHV19SvrPLMmhDCZjpBUIP4Tkket82sEIYT96TDVEA1Y1B7wYPeEi2kDfQe1Po2spnQ0ceetYXabk7Vk2pyGmkOeMZM8mdZvUveUNlPSeL6MTtllpc9OaIYrhBBCCCGEEANQFMUXIYTvSJ4rH964SfIeycflYt0KgFcpytfpvcfldxbK35xLZaSyZEIfgpM8A+Anko8AvBniSmgq68+y7DMypKTT6YwDOAvgtzqfkCmfH/41/ffS0tJnbX0O+DJJX5fo/xEFgEtFURxyo87a2tqBdCa/5ufBYp+t4jXJGyO5glqu7V9Ip5Gtheb/G5Gu8XyMcY8bBbz3x0n+ZS0stx+PvPfHXFOJMe4i+YPl8XPuvDWsl63hI9ckUvMF8LO1gBxeLDTmKEuv1/uc5J0MRItDjtsrKyv7XO7iG5/3jxXH3WxNiDF+nCZUGYgUK47fY4y7XW6QvJKBOPH9GCCPfsqddzkB4HtroVmvAWmEdNblQK/XO8gNWmUAyZDFrBnAL9Yi08aA1ApuVaNqRRc8agZwgPKHjrXAlAH2IlMtwF5oqguyF5sNMLh19wDKAHuRqBZgLxQrCuseSAghhBBCCCGEEEIIIYQQQgghhMuWt7WGiLXLEz59AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_31_3428",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEBElEQVR4nO2dTY8VRRSGD4MfxA9kKSuYMXGjbDRxL7DCP8AkxD+AGHdGE6PGGCfEoEYdNoQd7GFrYAFbYlTGhboVxvHeTPd9356JJuIxHa8Jmcx0lfdW3ZrTc5519z3V79NdVV3dPSPiOI7jOI7jOI7jOI7jOLsQkh+UbsOeDp+klm7Hng6fLqBs+HQBZcOnCygbPl1A2fDpAsqGTxdQNny6gLLh0wWUDZ8uoGz4dAFlw6cLKBs+Mwoguaiqj8peYNLwmUnAf+0BcEVV56TPTBM+MwjYpj3npa9MGz4TC+hoz6L0jRThM6GAQHuqqqrmpS+kCp+JBES257aq7hPrpAyfiQQA+DKmVtM0r4tlUofPRAJUdT/Ja6FaAO4Ph8ODYpEc4TPhGDAYDJ4m+XOEhPfFGrnCZ+JZUNM0LwH4M1BzoKpPiBVyhs889wFLEXXPpa77fxp4DMAXAFZINjnDZWIBTdM8G9pmbW3tKQC/BrqhuzJrVPVxkssAHpQOnRMIaK9EAL/Vdf1cxLZvRtQ+JrMMH8DN0mFzQgEPd4MAvlPVA13br66uPtn29YHaHycLOOIALpYOmhMK2GEMWgrtB+CzrroAvk0WcESf/8CiAO4wAWhnOnVdL3TtW9f1KwEBf1VVdUhyA+Dz0iFzAgERs6/liGPvHIxHo9FryQPf5kB+tCagqqr5iPl8HXrg0j4PCFwF70puSMLoFXA2Yv/jgWMP/cblLKFvaYRaFKCqcwB+CJzBnwaO/USg/u0soW9phEkBMWcwgG+kg83NzSOB+j9JbiwLGI1GzwcErEQs0HXtf19yY1mA/nsD+XfH/sPA/nOBKTgkN8YFHAgIGEwpYCS56XkXdHfKLuie5MayAJJvTDMIV1V1NFDfB2HpeMzYnuFTTkNPBgTcktwYvhE7F7H/qxZuxMwtRdR1vZBoKeJq4Ap6J1vwe2Ax7uuu427fAWoH2a7faJrmVJbQtxzIi+3SqzUBgeXoP0JvusUsR6+vrz8js6A9WywK6JDwiUz/QOaOzApVfQzADYsCWkh+OMEjyWGg9kcyS8YSvtpt3ZFE0koYP5RfiNj2rYjaL0gJ2sIALozn2LQioKVpmsMSoL37DQ2+AL4XKxh8Met8RN2zYgkrryZubGy8HHH/8LupVxOtvJw7HA4PkvwlVA/Ae2KVXfx6+iMkr0eEf68dI8QyAN7eTQJUdR/JS5H1zkgfMPqJ0q1efKKU+kqQ2bSn/UjvqPSNFBJkNu05LX3FwIfaS9J3prkSJGN7xn+qoD/9fhf+xzqMXgnilJUgTlkJ4pSVIE5ZCeKUlSBOWQnilJUgTlkJ4pSVIE5ZCeKUlSBOOej/xspxHMdxHMdxHMdxHMcRu/wDXxeVRrWQw7kAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexterCall);
export default __webpack_public_path__ + "static/media/DexterCall.9421871a715c3b1090c52ea0d8a659ab.svg";
export { ForwardRef as ReactComponent };